export const getFullName = state => `${state.getIn(['welcome', 'firstName'])} ${state.getIn(['welcome', 'lastName'])}`;
